/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { palette } from 'styles/colors'
import Stepper from 'components/Dashboard/Stepper'
import EventStatusText from 'components/Dashboard/EventStatusText'

export const EVENT_STATUSES = {
  created: 1,
  pending: 2,
  pending_doctor: 2,
  pending_patient: 3,
  during: 3,
  medcard: 4,
  grade: 5,
  rate: 6,
  cancelled: 6
}

const event = {
  status: 'pending',
  staging: {
    1: {
      status: 'created',
      success: true
    },
    2: {
      status: 'pending',
      success: false
    },
    3: {
      status: 'pending_patient',
      success: false
    },
    4: {
      status: 'medcard',
      success: false
    },
    5: {
      status: 'grade',
      success: false
    },
    6: {
      status: 'finished',
      success: false,
      message: 'Качество консультации врачом 🔥'
    }
  }
}

const formatDate = (date) => {
  let receptionDate =
    date.split('-')[2] + '.' + date.split('-')[1] + '.' + date.split('-')[0]
  return receptionDate
}

const formatTime = (time) => {
  let receptionTime = time.split(':')[0] + ':' + time.split(':')[1]
  return receptionTime
}

const EventRow = ({ event }) => {
  const [backgroundColor, setBackgroundColor] = useState('white')

  return (
    <TableRow style={{ backgroundColor }} key={event.id}>
      <TableCell
        style={{
          width: '20px',
          borderColor: palette.black,
          height: '40px',
          fontSize: '1em'
        }}
        align="center"
      >
        {formatDate(event.receptionDate)}
      </TableCell>
      <TableCell
        style={{ width: '20px', borderColor: palette.black, fontSize: '1em' }}
        align="center"
      >
        {formatTime(event.receptionTime)}
      </TableCell>
      <TableCell
        style={{ width: '50px', borderColor: palette.black, fontSize: '1em' }}
        align="center"
      >
        {event.patientName}
      </TableCell>
      <TableCell
        style={{ width: '50px', borderColor: palette.black, fontSize: '1em' }}
        align="center"
      >
        {event.specialistName}
      </TableCell>
      <TableCell
        style={{ width: '50px', borderColor: palette.black, fontSize: '1em' }}
        align="center"
      >
        {event.coordinatorName}
      </TableCell>
      <TableCell
        style={{ width: '50px', borderColor: palette.black, fontSize: '1em' }}
        align="center"
      >
        <EventStatusText event={event} />
      </TableCell>
      <TableCell
        style={{ width: '300px', borderColor: palette.black, fontSize: '1em' }}
        align="center"
      >
        <Stepper event={event} setBackgroundColor={setBackgroundColor} />
      </TableCell>
    </TableRow>
  )
}

const Events = ({ classes, events }) => {
  return events.map((event) => {
    return <EventRow event={event} />
  })
}
const styles = () => ({})

export default withStyles(styles)(Events)
